// @flow

export type LikeType = 'like';

export default class LikeFilter {
  type: LikeType;
  dimension: string;
  pattern: string;
  values: void;
  fields: void;
  field: void;
  constructor(dimension: string, value: string) {
    this.type = 'like';
    this.dimension = dimension;
    this.pattern = value;
  }
}

export class StartsWithFilter extends LikeFilter {
  constructor(dimension: string, value: string) {
    super(dimension, `${value}%`);
  }
}

export class EndsWithFilter extends LikeFilter {
  constructor(dimension: string, value: string) {
    super(dimension, `%${value}`);
  }
}

export class ContainsFilter extends LikeFilter {
  constructor(dimension: string, value: string) {
    super(dimension, `%${value}%`);
  }
}
